<i18n>
  {
    "fr": {
      "one-way-flight": "Aller Simple",
      "two-way-flight": "Aller Retour",
      "placeholder": "Type de voyage"
    },
    "en": {
      "one-way-flight": "One way",
      "two-way-flight": "Round trip",
      "placeholder": "Travel type"
    }
  }
</i18n>

<template>
  <div id="travel-type">
    <div>
      <v-select
        id="travel-type-v-select"
        v-model="travelType"
        solo
        flat
        :items="travelTypes"
        item-text="name"
        item-value="value"
        class="body-2 travel-type-select"
        return-object
        :placeholder="$t('placeholder')"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'FlightSelectTravelType',

  computed: {
    ...mapState({
      travelTypeState: state => state.fb.searchParameters.travelType
    }),
    travelType: {
      /**
       * Simply return the vueX store state
       * @return {string}
       */
      get () {
        return this.travelTypeState
      },
      /**
       * Set a new value to vueX store state
       * @param newValue {Object}
       */
      set (newValue) {
        this.changeTravelType(newValue.value)
      }
    },
    /**
     * Simply regroup the different kind of travel types into an array and return it
     * @return {({name: string, value: string}|{name: string, value: string})[]}
     */
    travelTypes () {
      return [this.oneWayFlight, this.twoWayFlight]
    },
    /**
     * Return an object for the v-select to use
     * @return {{name: string, value: string}}
     */
    oneWayFlight () {
      const translation = this.$i18n.t('one-way-flight')
      return {
        name: translation,
        value: 'one-way'
      }
    },
    /**
     * Return an object for the v-select to use
     * @return {{name: string, value: string}}
     */
    twoWayFlight () {
      const translation = this.$i18n.t('two-way-flight')
      return {
        name: translation,
        value: 'two-way'
      }
    }
  },
  methods: {
    ...mapMutations({
      changeTravelType: 'fb/searchParameters/changeTravelType'
    })
  }
}
</script>

<style scoped>
#top-div >>> .v-menu__content {
  left: auto !important;
  top: auto !important;
}
</style>
